import { configure } from 'mobx';
export default function useStrict(strictMode) {
    configure({ enforceActions: strictMode ? 'observed' : 'never' });
}
